import { AsyncIterableX } from './asynciterablex';

export class ReverseAsyncIterable<TSource> extends AsyncIterableX<TSource> {
  private _source: AsyncIterable<TSource>;

  constructor(source: AsyncIterable<TSource>) {
    super();
    this._source = source;
  }

  async *[Symbol.asyncIterator]() {
    let results = [] as TSource[];
    for await (let item of this._source) {
      results.unshift(item);
    }
    yield* results;
  }
}

export function reverse<TSource>(source: AsyncIterable<TSource>): AsyncIterableX<TSource> {
  return new ReverseAsyncIterable<TSource>(source);
}



// WEBPACK FOOTER //
// ./node_modules/ix/asynciterable/reverse.ts